// extracted by mini-css-extract-plugin
export default {"image":"E2-z","loaded":"F2-z"};